export function isEmail(email: string): boolean {
  return /^.+@.+\..+$/.test(email);
}



// WEBPACK FOOTER //
// ./src/utils/validators.ts